import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { styleMap } from "../config";
import API from "../services/ServiceApi";
const mapOptions = {
  disableDefaultUI: true,
  draggable: false,
  scrollwheel: false,
  disableDoubleClickZoom: true,
  zoomControl: false,
  styles: styleMap,
};

const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      defaultZoom={props.zoom}
      defaultCenter={props.center}
      options={mapOptions}
    >
      {props.isMarkerShown && (
        <Marker
          position={props.center}
          icon={API.absoluteUrl("/icon/pin_plan.png")}
        />
      )}
    </GoogleMap>
  ))
);

class MapFullDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    console.log("start");
  }

  render() {
    return (
      <MyMapComponent
        center={this.props.center}
        zoom={this.props.zoom}
        isMarkerShown
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCTm1QKX4uGPhsUqkF2-TfZXyH4lr-P1Vs&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    );
  }
}
export default MapFullDetail;
